import AppHistory from './AppHistory';
import CordovaUtils from './Cordova';
export var ipcRenderer = window.ipcRenderer;
var ElectronHelpers = /** @class */ (function () {
    function ElectronHelpers() {
    }
    /**Minimize window */
    ElectronHelpers.prototype.Init = function () {
        return CordovaUtils.IsElectron ? ipcRenderer.sendSync('window-init', process.env.REACT_APP_NATIVE_NAME) : true;
    };
    /**Close identity server window*/
    ElectronHelpers.prototype.CloseIdsWindow = function () {
        ipcRenderer.sendSync('window-close-ids');
    };
    /**Navigate back*/
    ElectronHelpers.prototype.Back = function () {
        AppHistory.history.goBack();
    };
    /**Navigate forward */
    ElectronHelpers.prototype.Forward = function () {
        AppHistory.history.goForward();
    };
    /**Refresh */
    ElectronHelpers.prototype.Refresh = function () {
        ipcRenderer.sendSync('window-refresh');
    };
    /**Minimize window */
    ElectronHelpers.prototype.Minimize = function () {
        ipcRenderer.sendSync('window-minimize');
    };
    /**Maximize window */
    ElectronHelpers.prototype.Maximize = function () {
        return ipcRenderer.sendSync('window-maximize');
    };
    /**Close window */
    ElectronHelpers.prototype.Quit = function () {
        ipcRenderer.sendSync('window-quit');
    };
    return ElectronHelpers;
}());
;
var ElectronUtils = new ElectronHelpers();
export default ElectronUtils;
//# sourceMappingURL=Electron.js.map